import MuiDrawer, { DrawerProps as MuiDrawerProps } from '@mui/joy/Drawer';
import { useBreakpoints } from '../hooks';
import DialogContent from '@mui/joy/DialogContent';
import DialogTitle from '@mui/joy/DialogTitle';
import { ModalClose } from '../Modal';
import React from 'react';

// 检查children中是否包含DialogContent组件
const hasDialogContent = (children: React.ReactNode): boolean => {
  let found = false;

  React.Children.forEach(children, (child) => {
    if (React.isValidElement(child)) {
      if (child.type === DialogContent || child.type === 'DialogTitle') {
        found = true;
      }
      const childType = child.type as any;
      if (
        childType &&
        typeof childType === 'function' &&
        (childType.displayName === 'DialogContent' ||
          childType.name === 'DialogContent' ||
          childType.displayName === 'DialogTitle' ||
          childType.name === 'DialogTitle')
      ) {
        found = true;
      }
      if ((childType && childType.muiName === 'DialogContent') || childType.muiName === 'DialogTitle') {
        found = true;
      }
    }
  });

  return found;
};

export type DrawerProps = {
  /**
   * Show close button in the drawer
   * v2 版本废弃 请使用 ModalClose 组件
   * @deprecated
   * @default false  when the device is mobile, the default is true.
   */
  showCloseButton?: boolean;
  /**
   * Title of the drawer
   * v2 版本废弃 请使用 DialogTitle 组件
   * @default `h3` old -> h2
   * @deprecated 请使用 DialogTitle 组件
   */
  title?: string | React.ReactNode;
  ActionsChildren?: React.ReactNode;
} & MuiDrawerProps;

export const Drawer = ({ showCloseButton = false, title, children, ActionsChildren, ...rest }: DrawerProps) => {
  const { xs, sm, md, lg } = useBreakpoints();
  const showClose = showCloseButton || xs;

  // 检查是否已经包含DialogContent
  const hasContentOrTitle = hasDialogContent(children);

  return (
    <MuiDrawer anchor={xs ? 'bottom' : 'right'} size={xs || sm || md ? 'sm' : lg ? 'md' : 'lg'} {...rest}>
      {showClose && <ModalClose />}
      {title && <DialogTitle level="h2">{title}</DialogTitle>}
      {hasContentOrTitle ? children : <DialogContent>{children}</DialogContent>}
      {ActionsChildren ? ActionsChildren : null}
    </MuiDrawer>
  );
};

export default Drawer;
